import { PopupProps } from 'react-popup-manager';
import { ConfirmationModalComponent } from 'commons/components';
import { PocTypography } from 'commons/components/components-wrapper/poc-typography.component';
import { useTranslation } from 'core/i18n/i18n';
import { getConfirmationTexts } from 'modules/settings/pods/settings-operator-custom-notifications/components/operator-custom-notifications-confirmation-modal/operator-custom-notifications-confirmation-modal.business';
import { OperatorCustomNotificationsConfirmationModalHeaderComponent } from 'modules/settings/pods/settings-operator-custom-notifications/components/operator-custom-notifications-confirmation-modal/operator-custom-notifications-confirmation-modal-header.component';
import {
    OperatorCustomNotificationAction,
    OperatorCustomNotificationRow,
} from 'modules/settings/pods/settings-operator-custom-notifications/settings-operator-custom-notifications.model';

export interface OperatorCustomNotificationsConfirmationModalComponentProps extends PopupProps {
    notifications: OperatorCustomNotificationRow[];
    action: OperatorCustomNotificationAction;
    onConfirm: () => Promise<void>;
}

export const OperatorCustomNotificationsConfirmationModalComponent: React.FC<
    OperatorCustomNotificationsConfirmationModalComponentProps
> = ({ notifications, action, onConfirm, isOpen, onClose }) => {
    const { t } = useTranslation();

    const { headerText, bodyText, confirmText } = getConfirmationTexts(action, notifications.length);

    return (
        <ConfirmationModalComponent
            isOpen={isOpen}
            onClose={onClose}
            title={
                <OperatorCustomNotificationsConfirmationModalHeaderComponent
                    notifications={notifications}
                    headerText={headerText}
                />
            }
            buttonText={t(confirmText)}
            isDeleteAction={action === 'delete'}
            actionOnClick={onConfirm}
        >
            <PocTypography variant="body1">{t(bodyText)}</PocTypography>
        </ConfirmationModalComponent>
    );
};
